import { Outlet, Link } from 'react-router-dom';
import './Layout.css';
import logo from '../assets/logo.png'; // import your logo
import CookieBanner from './CookieBanner';

function Layout() {
  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="KEHSEF d.o.o." className="logo-img" />
            </Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Početna</Link></li>
            <li><Link to="/usluge">Usluge</Link></li>
            <li><Link to="/o-nama">O nama</Link></li>
            <li><Link to="/kontakt">Kontakt</Link></li>
          </ul>
        </div>
      </nav>
      
      <main className="content">
        <Outlet />
             <CookieBanner />
      </main>
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>KEHSEF d.o.o.</h3>
            <p>Poslovno savjetovanje, informatika i usluge</p>
          </div>
          <div className="footer-section">
            <h4>Kontakt</h4>
            <p>Email: info@kehsef.hr</p>
          </div>
          <div className="footer-section">
            <h4>Lokacija</h4>
            <p>Zagreb, Hrvatska</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 KEHSEF d.o.o.</p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
